import CONSTANTS from '../constants'
import MUTATION_TYPES from '../mutation-types/favorite-mutation-types.js'

export default {
  // Favorites
  [MUTATION_TYPES.SET_FAVORITES_SORT_AND_FILTER]: (state, sortAndFilterData) => {
    state[CONSTANTS.FAVORITES_SORT_AND_FILTER] = sortAndFilterData
  },
  // [MUTATION_TYPES.SET_FAVORITES_FILTER_DATA]: (state, filterData) => {
  //   state[CONSTANTS.FAVORITES_FILTER_DATA] = filterData
  // },
}
